import * as THREE from 'three';

import type { FbxAxisName, FbxUpAxisMetadata } from './fbxAxisSystem';
import { normalizeQuaternion } from '../skeleton/rotationService';

const TARGET_UP_AXIS = new THREE.Vector3(0, 1, 0);

export function getSignedFbxAxisVector(
  axis: FbxAxisName,
  sign: 1 | -1,
): THREE.Vector3 {
  switch (axis) {
    case 'x':
      return new THREE.Vector3(sign, 0, 0);
    case 'y':
      return new THREE.Vector3(0, sign, 0);
    case 'z':
      return new THREE.Vector3(0, 0, sign);
    default: {
      const exhaustiveCheck: never = axis;
      return exhaustiveCheck;
    }
  }
}

export function createFbxUpAxisCorrection(
  metadata: FbxUpAxisMetadata,
): THREE.Quaternion | null {
  if (metadata.upAxis === 'y' && metadata.upSign === 1) {
    return null;
  }

  return normalizeQuaternion(
    new THREE.Quaternion().setFromUnitVectors(
      getSignedFbxAxisVector(metadata.upAxis, metadata.upSign),
      TARGET_UP_AXIS,
    ),
  );
}
